import { AKA_HOUSE_CONTENTS_INTRO_STEP } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/AkaHouseContents";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { formBooleanToBoolean } from "Utils/formUtils";

export type AkaHouseContentsProductBackend = {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: any;
  addressSameAsHomeAddress: boolean;
  address?: {
    zipCode: string;
    city?: string;
  };
  coverageAmount: number;
};

export const mapToCommerceAkaHouseContents = (
  data: Record<string, any>,
): AkaHouseContentsProductBackend => {
  const intro = data.formData[AKA_HOUSE_CONTENTS_INTRO_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS,
    coverageGroup: data.coverage,
    addressSameAsHomeAddress: formBooleanToBoolean(
      intro.addressSameAsHomeAddress,
    ),
    address:
      intro.city && intro.postNumber
        ? {
            city: intro.city,
            zipCode: intro.postNumber,
          }
        : undefined,
    coverageAmount: intro.coverageAmount,
  };
};
